import axios from 'axios'
import { Button, NumberInput, Stack, TextInput } from '@mantine/core'
import { useForm } from '@mantine/form'
import { useMutation } from '@tanstack/react-query'

interface Props {
  imei: string | null
  delivery_method: string | null
}

export default function Gtsri({ imei, delivery_method }: Props) {
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      main_server: '',
      main_server_port: 8020,
    },
    validate: {
      main_server_port: (value) =>
        value > 0 && value < 65535
          ? null
          : 'Port should be between 0 and 65535',
    },
  })

  const postConfiguration = useMutation({
    mutationFn: async (values: any) => {
      return axios.post(`/api/device/${imei}/configure`, values)
    },
  })

  return (
    <Stack>
      <div>
        <form
          onSubmit={form.onSubmit((values) => {
            const data = {
              delivery_method: delivery_method!,
              params: {
                kind: 'GTSRI',
                main_server: values.main_server,
                main_server_port: values.main_server_port,
              },
            }
            postConfiguration.mutate(data)
          })}
        >
          <TextInput
            label="Main server IP"
            placeholder="data.sense4boat.com"
            required
            key={form.key('main_server')}
            {...form.getInputProps('main_server')}
          />
          <NumberInput
            label="Main server port"
            required
            placeholder="8020"
            key={form.key('main_server_port')}
            {...form.getInputProps('main_server_port')}
          />
          <Button type="submit" mt="md">
            Configure
          </Button>
        </form>
      </div>
      <div>
        {postConfiguration.isPending && (
          <div style={{ padding: '10px 0px' }}>
            <span>Configuring...</span>
          </div>
        )}
        {postConfiguration.isSuccess && (
          <div style={{ padding: '10px 0px' }}>
            <span>Configuration sent successfully!</span>
          </div>
        )}
        {postConfiguration.isError && (
          <div style={{ padding: '10px 0px' }}>
            <span>Error sending configuration!</span>
          </div>
        )}
      </div>
    </Stack>
  )
}
